export default {
  LOAD_CYCLE_SKILL_ABILITY_LIST_START: 'LoadCycleSkillAbilityListStart',
  LOAD_CYCLE_SKILL_ABILITY_LIST_END: 'LoadCycleSkillAbilityListEnd',
  TOGGLE_CYCLE_SKILL_ABILITY_LIST_CONFIRM_DIALOG: 'ToggleCycleSkillAbilityListConfirmDialog'
};